import { PlaceholderScreen } from "@/shell/PlaceholderScreen";
import { OrdersIcon } from "@/ui/icons/OrdersIcon";

export default function Orders() {
  return (
    <PlaceholderScreen
      title="Orders"
      testID="placeholder-orders"
      Icon={OrdersIcon}
      tile="tileGreen"
      message="Coming soon. Your orders and their delivery status will be here."
      homeLink
    />
  );
}
